import { useEffect, useState } from "react";
import EditPost from "./EditPost";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { PostItem } from "../../../types/admin";
import { Admin_GetPostById } from "../../../constants/adminData";

export default function EditPostScreen() {
  const navigate = useNavigate();
  const { postId } = useParams<{ postId: string }>();
  const location = useLocation();
  const statePost = location.state?.post as PostItem | null;

  const [post, setPost] = useState<PostItem | null>(statePost ?? null);
  const [isLoading, setIsLoading] = useState(!statePost);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (statePost || !postId) return;

    let cancelled = false;
    setIsLoading(true);
    setError(null);

    Admin_GetPostById(postId)
      .then((response) => {
        if (cancelled) return;
        if (response?.success && response.data) {
          setPost(response.data);
        } else {
          setError(response?.message || "Post not found");
        }
      })
      .catch(() => {
        if (!cancelled) setError("Failed to load post");
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [postId, statePost]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error || !post) {
    return (
      <div>
        <p>{error || "Post not found"}</p>
        <button type="button" onClick={() => navigate(-1)}>
          Go Back
        </button>
      </div>
    );
  }

  return (
    <EditPost
      post={post}
      onBack={() => navigate(-1)}
      onUpdate={(updatedPost) => {
        setPost(updatedPost);
      }}
    />
  );
}
